module.exports = __webpack_public_path__ + "static/media/404.6d115e79.svg";